import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "containerTech",
  "use": "containerTech-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"containerTech\"><path d=\"M10.42 1.81c-.46-.34-1.02-.53-1.59-.53-.41 0-.82.1-1.19.28L2.61 4.08l4.45 3.34 6.5-3.25zm-1.79.5c.07-.01.13-.02.2-.02.02 0 .04.01.06.01a.8.8 0 0 0-.26.01M2 9.47c0 .65.31 1.26.83 1.65L6.4 13.8l.1.08V8.25L2 4.88zm5.5-1.16v5.56l1.5-.75V9.5c0-.28.22-.5.5-.5s.5.22.5.5v3.12l1-.5V8.5c0-.28.22-.5.5-.5s.5.22.5.5v3.12l.86-.43c.7-.35 1.14-1.06 1.14-1.85V5.06z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol